const recognition = {
  //营业执照临时
  ocrBusinessLicense: {
    name: 'home.business',
    dec: 'home.businessDec',
    rightDec: '',
    experience: ['信息提取全面', '识别速度快捷', '高准确度保证'],
    banner: new URL('/public/new-image/text-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/ocr_business_license/case1/ori.jpg',
            import.meta.url
          ),
          label: [
            {
              label: '统一社会信用代码',
              value: '90123456789648921U',
            },
            {
              label: '证件编号',
              value: '12345678202501110210',
            },
            {
              label: '名称',
              value: '人工智能算法超市科技有限公司',
            },
            {
              label: '类型',
              value: '有限责任公司（自然人独资）',
            },
            {
              label: '营业场所',
              value: '上海市某某区某某路001号',
            },
            {
              label: '负责人',
              value: '张三',
            },
            {
              label: '成立日期',
              value: '2025年1月11日',
            },
            {
              label: '营业期限',
              value: '2025年1月11日 至 2055年1月11日',
            },
            {
              label: '经营范围',
              value:
                '软件开发；信息系统集成服务；信息技术咨询服务；数据处理和存储服务；计算机软硬件及辅助设备零售。（依法须经批准的项目，经相关部门批准后方可开展经营活动）',
            },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.businessApply',
        src: new URL(
          '/public/new-image/ocr_business_license/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  //银行卡临时
  ocrBankCard: {
    name: 'home.bank',
    dec: 'home.bankDec',
    rightDec: '',
    experience: ['卡号快速识别', '安全性保障好', '高效处理能力'],
    banner: new URL('/public/new-image/text-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/ocr_bank_card/case1/ori.jpg',
            import.meta.url
          ),
          label: [
            { label: '卡号', value: '0000 0000 0000 0001' },
            { label: '有效期', value: '01/23' },
            { label: '持卡人姓名', value: 'CARDHOLDER NAME' },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.bankApply',
        src: new URL(
          '/public/new-image/ocr_bank_card/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  //发票信息临时
  ocrInvoiceInformation: {
    name: 'home.invoice',
    dec: 'home.invoiceDec',
    rightDec: '',
    experience: ['发票项目齐全', '提取速度快捷', '高准确度识别'],
    banner: new URL('/public/new-image/text-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL('/public/image/invoice/ori-1.png', import.meta.url),
          label: [
            { label: '发票类型', value: '电子发票（通发票）' },
            { label: '开票日期', value: '2025年03月30日' },
            { label: '税务局名称', value: '上海市税务局' },
            { label: '销售方名称', value: '上海圆迈贸易有限公司' },
            { label: '购买方名称', value: '上海移远通信技术股份有限公司' },
            { label: '购买方纳税人识别号', value: '913100005631196115' },
            { label: '销售方纳税人识别号', value: '91310114666025597Y' },
            { label: '项目名称', value: '计算机外部设备' },
            { label: '规格型号', value: '256GB USB3.2Gen1U盘' },
            { label: '单位', value: '个' },
            { label: '数量', value: '1' },
            { label: '单价', value: '105.31' },
            { label: '税率', value: '13%' },
            { label: '税额', value: '13.69' },
            { label: '价税合计', value: '118.41' },
            { label: '价税合计大写', value: '壹佰壹拾捌圆肆角壹分' },
            { label: '订单号', value: '312166494883' },
            { label: '开票人', value: '王梅' },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.invoiceApply1',
        src: new URL(
          '/public/new-image/ocr_invoice_information/site/site-1.jpg',
          import.meta.url
        ),
      },
      {
        name: 'home.invoiceApply2',
        src: new URL(
          '/public/new-image/ocr_invoice_information/site/site-2.jpg',
          import.meta.url
        ),
      },
    ],
  },
  //驾驶证临时
  ocrDriverLicense: {
    name: 'home.driver',
    dec: 'home.driverDec',
    rightDec: '',
    experience: ['证件信息完整', '高效识别技术', '支持多种版本'],
    banner: new URL('/public/new-image/text-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/ocr_driver_license/case1/ori.jpg',
            import.meta.url
          ),
          label: [
            {
              label: '姓名',
              value: '某某某',
            },
            {
              label: '证号',
              value: '11123456789012345',
            },
            {
              label: '性别',
              value: '男',
            },
            {
              label: '国籍',
              value: '中国',
            },
            {
              label: '住址',
              value: '某某省某某市某某县某某路某某号',
            },
            {
              label: '出生日期',
              value: '2025-01-11',
            },
            {
              label: '初次领证日期',
              value: '2025-01-11',
            },
            {
              label: '准驾车型',
              value: 'C1',
            },
            {
              label: '有效期限',
              value: '2025-01-11至2055-01-11',
            },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.driverApply',
        src: new URL(
          '/public/new-image/ocr_driver_license/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  //驾驶行为分析临时
  bodyDriverMonitoring: {
    name: 'home.behavior',
    dec: 'home.behaviorDec',
    rightDec: 'home.qrResult',
    experience: ['行为模式学习', '安全预警提示', '数据驱动改进'],
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_driver_monitoring/case1/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_driver_monitoring/case1/cut_0.png',
            import.meta.url
          ),
          label: 'call',
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_driver_monitoring/case2/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_driver_monitoring/case2/cut_0.png',
            import.meta.url
          ),
          label: 'sleepy',
        },
      ],
    },
    application: [
      {
        name: 'home.behaviorApply',
        src: new URL(
          '/public/new-image/body_driver_monitoring/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  //人体属性
  bodyAttribute: {
    name: 'home.bodyAttributes',
    dec: 'home.bodyAttributesDec',
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    experience: ['分析结果准确', '支持批量处理'],
    rightDec: '信息',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_attribute/case1/ori_bbox.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_attribute/case1/cut_0.jpg',
            import.meta.url
          ),
          label: [
            { label: 'gender', value: 'male' },
            { label: 'hat', value: false },
            { label: 'upper', value: 'shortsleeve' },
            { label: 'lower', value: 'trousers' },
          ],
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_attribute/case2/ori_bbox.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_attribute/case2/cut_0.jpg',
            import.meta.url
          ),
          label: [
            { label: 'gender', value: 'male' },
            { label: 'hat', value: false },
            { label: 'upper', value: 'longsleeve' },
            { label: 'lower', value: 'trousers' },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.crowd',
        src: new URL(
          '/public/new-image/body_attribute/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  facePhotoClustering: {
    // name: 'home.album',
    // dec: 'home.albumDec',
    // application: [
    //   {
    //     name: 'home.albumApply',
    //     src: new URL('/public/image/apply/album-apply.png', import.meta.url),
    //   },
    // ],
  },
  faceAppearanceLevel: {
    name: 'home.beauty',
    dec: 'home.beautyDec',
    banner: new URL('/public/new-image/face-1.png', import.meta.url),
    rightDec: '',
    experience: ['面部特征分析', '美感评分系统', '个性化推荐准'],
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/face_appearance_level/case1/ori.jpg',
            import.meta.url
          ),
          label: [
            { label: '20分', value: 0.0123 },
            { label: '40分', value: 0.0143 },
            { label: '60分', value: 0.0139 },
            { label: '80分', value: 0.0293 },
            { label: '100分', value: 0.8829 },
          ],
        },
      ],
    },
    application: [
      {
        name: '线上交友',
        src: new URL(
          '/public/new-image/face_appearance_level/site/site-1.jpg',
          import.meta.url
        ),
      },
      {
        name: '线上美妆带货',
        src: new URL(
          '/public/new-image/face_appearance_level/site/site-2.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyFightRecognition: {},
  ocrTable: {
    // name: 'home.table',
    // dec: '',
    // application: [
    //   {
    //     name: 'home.tableApply1',
    //     src: new URL(
    //       '/public/image/industry_solution/tableApply1.png',
    //       import.meta.url
    //     ),
    //   },
    //   {
    //     name: 'home.tableApply2',
    //     src: new URL(
    //       '/public/image/industry_solution/tableApply2.png',
    //       import.meta.url
    //     ),
    //   },
    // ],
  },
  imageTechProductSearch: {
    // name: 'home.product',
    // application: [
    //   {
    //     name: 'home.productApply1',
    //     src: new URL('/public/image/product-apply1.png', import.meta.url),
    //   },
    //   {
    //     name: 'home.productApply2',
    //     src: new URL('/public/image/product-apply2.png', import.meta.url),
    //   },
    // ],
  },
  imageTechElimination: {
    // name: 'home.Inpainting',
    // application: [
    //   {
    //     name: 'home.InpaintingApply1',
    //     src: new URL('/public/image/Inpaint-apply1.png', import.meta.url),
    //   },
    //   {
    //     name: 'home.InpaintingApply2',
    //     src: new URL('/public/image/Inpaint-apply2.png', import.meta.url),
    //   },
    // ],
  },
  imageTechDefogging: {
    name: 'home.dehazing',
    dec: '',
    rightDec: '',
    experience: ['清晰度显著提升', '处理速度快捷'],
    banner: new URL('/public/new-image/image-tech-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/image_tech_defogging/case1/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/image_tech_defogging/case1/cut_1.png',
            import.meta.url
          ),
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/image_tech_defogging/case2/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/image_tech_defogging/case2/cut_1.png',
            import.meta.url
          ),
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/image_tech_defogging/case3/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/image_tech_defogging/case3/cut_1.png',
            import.meta.url
          ),
        },
      ],
    },
    application: [
      {
        name: 'home.dehazingApply1',
        src: new URL(
          '/public/new-image/image_tech_defogging/site/site-1.jpg',
          import.meta.url
        ),
      },
      {
        name: 'home.dehazingApply2',
        src: new URL(
          '/public/new-image/image_tech_defogging/site/site-2.jpg',
          import.meta.url
        ),
      },
    ],
  },
  imageTechColorEnhancement: {
    name: 'home.color',
    dec: '',
    rightDec: '',
    experience: ['色彩更加鲜艳', '对比度显著增加'],
    banner: new URL('/public/new-image/image-tech-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/image_tech_color_enhancement/case1/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/image_tech_color_enhancement/case1/cut_0.jpg',
            import.meta.url
          ),
        },
      ],
    },
    application: [
      {
        name: 'home.colorApply1',
        src: new URL(
          '/public/new-image/image_tech_color_enhancement/site/site-1.jpg',
          import.meta.url
        ),
      },
      {
        name: 'home.colorApply2',
        src: new URL(
          '/public/new-image/image_tech_color_enhancement/site/site-2.jpg',
          import.meta.url
        ),
      },
    ],
  },
  imageTechGeneration: {
    name: 'home.generation',
    dec: '',
    rightDec: '',
    experience: ['创意图像生成', '高效处理速度', '支持多种风格'],
    banner: '',
    cutOutImage: {
      1: [
        {
          url: new URL('/public/image/generator-1.png', import.meta.url),
          label:
            '帮我画一个深秋初冬氛围的静物摄影图，主体内容是咖啡、书本，画面干净，光线清晰，咖啡蒸汽明显，背景是一扇明亮的窗户，窗外是深秋，高画质，超清细节。',
        },
      ],
    },
    application: [
      {
        name: 'home.generationApply1',
        src: new URL('/public/image/generation-apply1.png', import.meta.url),
      },
      {
        name: 'home.generationApply2',
        src: new URL('/public/image/generation-apply2.png', import.meta.url),
      },
    ],
  },
  imageTechStyleTransfer: {
    name: 'home.style',
    application: [
      {
        name: 'home.styleApply1',
        src: new URL('/public/image/style-apply1.jpg', import.meta.url),
      },
      {
        name: 'home.styleApply2',
        src: new URL('/public/image/style-apply2.jpg', import.meta.url),
      },
    ],
  },
  imageTechOddCoincidenceFrame: {
    name: 'home.odd',
  },
  detectionSmoke: {
    name: 'home.smoke',
    dec: 'home.smokeDec',
    rightDec: '',
    banner: new URL(
      '/public/new-image/classification-banner.jpg',
      import.meta.url
    ),
    experience: ['烟雾及时发现', '高精度检测', '实时告警功能'],
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/detection_smoke/case1/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/detection_smoke/case1/cut_0.png',
            import.meta.url
          ),
        },
      ],
    },
    application: [
      {
        name: 'home.smokeApply1',
        src: new URL(
          '/public/new-image/detection_smoke/site/site-1.jpg',
          import.meta.url
        ),
      },
      {
        name: 'home.smokeApply2',
        src: new URL(
          '/public/new-image/detection_smoke/site/site-2.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyGestureRecognition: {
    name: 'home.recognition',
    dec: 'home.recognitionDec',
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    rightDec: '结果信息',
    experience: ['实时识别反馈', '动作捕捉精准'],
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_gesture_recognition/case1/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_gesture_recognition/case1/cut_0.png',
            import.meta.url
          ),
          label: 'ok',
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_gesture_recognition/case2/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_gesture_recognition/case2/cut_0.png',
            import.meta.url
          ),
          label: 'plam',
        },
      ],
    },
    application: [
      {
        name: 'home.recognition',
        src: new URL(
          '/public/new-image/body_gesture_recognition/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
}

const businessList = [
  new URL(
    '/public/new-image/ocr_business_license/case1/ori.jpg',
    import.meta.url
  ),
]
const bankList = [
  new URL('/public/new-image/ocr_bank_card/case1/ori.jpg', import.meta.url),
]
const invoiceList = [
  new URL('/public/image/invoice/ori-1.png', import.meta.url),
]
const driverLicenseList = [
  new URL(
    '/public/new-image/ocr_driver_license/case1/ori.jpg',
    import.meta.url
  ),
]
const appearanceList = [
  new URL(
    '/public/new-image/face_appearance_level/case1/ori.jpg',
    import.meta.url
  ),
]
const handWrittenList = [
  new URL('/public/image/handcut-1.png', import.meta.url),
]
const classList = [new URL('/public/image/class-1.png', import.meta.url)]
const smokeList = [
  new URL('/public/new-image/detection_smoke/case1/ori.png', import.meta.url),
]
const plantList = [new URL('/public/image/plant-1.png', import.meta.url)]

const techSuperList = [
  new URL(
    '/public/new-image/image_tech_defogging/case1/ori.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/image_tech_defogging/case2/ori.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/image_tech_defogging/case3/ori.png',
    import.meta.url
  ),
]
const colorList = [
  new URL(
    '/public/new-image/image_tech_color_enhancement/case1/ori.jpg',
    import.meta.url
  ),
]
const generatorList = [
  new URL('/public/image/generator-1.png', import.meta.url),
]
const driverList = [
  new URL(
    '/public/new-image/body_driver_monitoring/case1/ori_bbox.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_driver_monitoring/case2/ori_bbox.png',
    import.meta.url
  ),
]
const bodyList = [
  new URL(
    '/public/new-image/body_attribute/case1/ori_bbox.jpg',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_attribute/case2/ori_bbox.jpg',
    import.meta.url
  ),
]
const gestureList = [
  new URL(
    '/public/new-image/body_gesture_recognition/case1/ori_bbox.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_gesture_recognition/case2/ori_bbox.png',
    import.meta.url
  ),
]

export {
  recognition,
  businessList,
  bankList,
  invoiceList,
  driverLicenseList,
  appearanceList,
  handWrittenList,
  classList,
  smokeList,
  plantList,
  techSuperList,
  colorList,
  generatorList,
  driverList,
  bodyList,
  gestureList,
}
